module.exports = __webpack_public_path__ + "img/Cross in circle.23c058e.png";